import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';

export const DiscountGroupLoadDetailsActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[discount-group] Load details'),
  requestFail: uniqueActionType('[discount-group] Load details fail'),
  requestSuccess: uniqueActionType('[discount-group] Load details success'),
  requestClearErrors: uniqueActionType('[discount-group] Load details clear errors'),
  requestClear: uniqueActionType('[discount-group] Load details clear')
};

export class DiscountGroupLoadDetailsAction implements PayloadAction {
  readonly type = DiscountGroupLoadDetailsActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class DiscountGroupLoadDetailsFailAction implements PayloadAction {
  readonly type = DiscountGroupLoadDetailsActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DiscountGroupLoadDetailsSuccessAction implements PayloadAction {
  readonly type = DiscountGroupLoadDetailsActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class DiscountGroupLoadDetailsClearAction implements PayloadAction {
  readonly type = DiscountGroupLoadDetailsActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class DiscountGroupLoadDetailsClearErrorsAction implements PayloadAction {
  readonly type = DiscountGroupLoadDetailsActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}
